import GlobalPrototypes from 'src/config/services/globalPrototypes.ts'

const defaultState = () => ({
  intervalId: null
})

export const state = defaultState()

export const mutations = {
  RESET_STATE (state) {
    Object.assign(state, defaultState())
  },
  SET_INTERVAL_ID (state, value) {
    state.intervalId = value
  },
  CLEAR_INTERVAL (state) {
    clearInterval(state.intervalId)
  }
}

export const actions = {

  initInterval ({ commit, dispatch, state, rootGetters, rootState }) {
    // make sure there is no previous interval
    state.intervalId && commit('CLEAR_INTERVAL', true)

    const me = rootGetters['users/me']
    const brandingConfig = rootGetters['schoolBranding/getBrandingConfig']

    // init ping keep alive only for specific brand(untis) when it was not init before and user is logged in
    if (rootState.isNative || !brandingConfig.keepAlivePing || !me || !!me?.properties?.is_ping_opted_out) return

    dispatch('validateAlive')
    const intervalId = setInterval(() => dispatch('validateAlive'), 10 * 1000)

    commit('SET_INTERVAL_ID', intervalId)
  },

  async validateAlive ({ dispatch, rootGetters }) {
    const buffer = 5

    const lastCheckUnix = localStorage?.getItem('keep_alive')
    if (!lastCheckUnix) return dispatch('setKeepAlivePing')

    const isExpired = GlobalPrototypes.moment.unix(lastCheckUnix).isBefore(GlobalPrototypes.moment().subtract(60 + buffer, 'seconds'))
    // tokens from the future are not valid
    const isInvalid = GlobalPrototypes.moment.unix(lastCheckUnix).isAfter(GlobalPrototypes.moment().add(buffer, 'seconds'))

    if (isExpired || isInvalid) {
      return await GlobalPrototypes.store.dispatch('users/logout', rootGetters['users/me'], { root: true })
    }

    dispatch('setKeepAlivePing')
  },

  async setKeepAlivePing ({ rootGetters }) {
    const brandingConfig = rootGetters['schoolBranding/getBrandingConfig']
    if (!brandingConfig.keepAlivePing) return
    localStorage?.setItem('keep_alive', GlobalPrototypes.moment().unix())
  }
}
